export function CtaButton({ label, url }: { label: string; url: string }) {
  const rel = url.startsWith("#") ? undefined : "noopener noreferrer";

  return (
    <a className="cms-btn" href={url} rel={rel}>
      {label}
      <span className="cms-btn__arrow" aria-hidden="true">
        &rarr;
      </span>
    </a>
  );
}
